import { render, staticRenderFns } from "./options.vue?vue&type=template&id=1c0b4bb4&scoped=true&"
import script from "./options.vue?vue&type=script&lang=ts&"
export * from "./options.vue?vue&type=script&lang=ts&"
import style0 from "./options.vue?vue&type=style&index=0&id=1c0b4bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0b4bb4",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox})
